module.exports = __webpack_public_path__ + "img/provider_Azure.9b35cf5f.svg";